import { RpcCredSSPOperationResult } from './rpc-credssp-model';

/**
 * Rpc CredSSP response sever side handler interface.
 */
export interface RpcCredSspResponseHandler {
    handler(data: RpcCredSSPOperationResult): Promise<void>;
}
